export const CLEAR_SELECTED_ROBOT_PART = 'CLEAR_SELECTED_ROBOT_PART';

export const clearSelectedRobotPart = () => ({
  type: CLEAR_SELECTED_ROBOT_PART,
  payload: {
  },
});
